import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import times from 'lodash/times';
import uniqueId from 'lodash/uniqueId';
import { bindAll } from '@bibliocommons/utils-react';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Star, HalfStar, StarOutline } from '@bibliocommons/base-icons';

import './RatingStars.scss';

const starCount = {
  fullStars: n => Math.floor(n / 20),
  halfStars: n => (n % 20 > 0 ? 1 : 0),
  emptyStars: n => 5 - Math.round(n / 20)
};

export class RatingStars extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
    this.id = uniqueId('rating-');
  }

  drawStars() {
    const { rating, size } = this.props;
    const stars = [];
    const normalizedRating = Math.round(rating / 10) * 10;

    times(starCount.fullStars(normalizedRating), n =>
      stars.push(<Star key={`star-${n}-${this.id}`} className={`rating-stars__icon--${size}`} />)
    );
    times(starCount.halfStars(normalizedRating), n =>
      stars.push(<HalfStar key={`half-star-${n}-${this.id}`} className={`rating-stars__icon--${size}`} />)
    );
    times(starCount.emptyStars(normalizedRating), n =>
      stars.push(<StarOutline key={`empty-star-${n}-${this.id}`} className={`rating-stars__icon--${size}`} />)
    );

    return stars;
  }

  render() {
    const { className, screenReaderLabel } = this.props;
    return (
      <span className={cn('cp-rating-stars', className)} aria-hidden={!screenReaderLabel}>
        {screenReaderLabel && <ScreenReaderMessage>{screenReaderLabel}</ScreenReaderMessage>}
        {this.drawStars()}
      </span>
    );
  }
}

RatingStars.defaultProps = {
  rating: 0,
  size: 'default'
};

RatingStars.propTypes = {
  className: PropTypes.string,
  rating: PropTypes.number,
  size: PropTypes.oneOf(['default', 'extra-extra-small', 'extra-small', 'small', 'medium', 'large']),
  screenReaderLabel: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

export default RatingStars;
